import api from './api';

export async function getSalesPriceList(
  pointOfSaleId,
  search = '',
  page = 1,
  perPage = 50,
  view = 'prices',
  enabledOnly,
) {
  const params = {
    point_of_sale_id: pointOfSaleId,
    search: search || undefined,
    page,
    per_page: perPage,
    view,
  };
  if (enabledOnly === true || enabledOnly === false) {
    params.enabled_only = enabledOnly;
  }
  const response = await api.get('/ventas/price-list', { params });
  return response.data;
}

export async function getSalesCatalogForVendible(search = '', pointOfSaleId = null, enabledOnly = false) {
  const response = await api.get('/ventas/catalog-vendible', {
    params: {
      search: search || undefined,
      point_of_sale_id: pointOfSaleId || undefined,
      enabled_only: enabledOnly || undefined,
    },
  });
  return response.data;
}

export async function updateSalesPriceListItem(productId, payload) {
  const response = await api.patch(`/ventas/price-list/${productId}`, payload);
  return response.data;
}

export async function updatePosMinPriceRange(payload) {
  const response = await api.patch('/ventas/price-list/min-range-settings', payload);
  return response.data;
}

export async function getSalesServicePriceList(pointOfSaleId, search = '', page = 1, perPage = 50) {
  const response = await api.get('/ventas/service-price-list', {
    params: {
      point_of_sale_id: pointOfSaleId,
      search: search || undefined,
      page,
      per_page: perPage,
    },
  });
  return response.data;
}

export async function updateSalesServicePriceListItem(serviceId, payload) {
  const response = await api.patch(`/ventas/service-price-list/${serviceId}`, payload);
  return response.data;
}

export async function bulkUpdatePriceList(payload) {
  const response = await api.patch('/ventas/price-list/bulk', payload);
  return response.data;
}

export async function bulkUpdatePosProducts(payload) {
  const response = await api.patch('/ventas/pos-products/bulk', payload);
  return response.data;
}

export default {
  getSalesPriceList,
  getSalesCatalogForVendible,
  updateSalesPriceListItem,
  updatePosMinPriceRange,
  bulkUpdatePriceList,
  getSalesServicePriceList,
  updateSalesServicePriceListItem,
  bulkUpdatePosProducts,
};
